// extracted by mini-css-extract-plugin
export default {"scanModal":"ScanBarcode_scanModal__CjbKS","bgModalGrey":"ScanBarcode_bgModalGrey__GYQuV","scanCodeReuslt":"ScanBarcode_scanCodeReuslt__0+1PR"};